import { Component, OnInit, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-consulta-resultado-ciac',
  templateUrl: './consulta-resultado-ciac.component.html',
  styleUrls: ['./consulta-resultado-ciac.component.scss']
})
export class ConsultaResultadoCiacComponent implements OnInit {

  @HostBinding('class.compacta') compacta: boolean = false;

  consultas: any = {}
  cabecalho;
  fotos;
  observacao;
  statusMsg = 'NÃO INFORMADO';
  tipoPessoa;
  @Input() dadosConsulta;
  consultasFilhas: any[];

  constructor() { }

  ngOnInit() {
    this.cabecalho = this.dadosConsulta.dadosResumoCredito;
    this.fotos = this.dadosConsulta.fotos;
    this.observacao = this.dadosConsulta.observacoes;
    this.consultas = this.ordenarConsulta();
    this.formatarConsultasFilhas();
  }

  ordenarConsulta() {
    let consultas = this.dadosConsulta.consultas;
    let consultasOrdenadas = [
      consultas.find(c => c.tipoConsulta === 'RELATORIO_SINTETICO_PLUS_SCORE_PF'),
      consultas.find(c => c.tipoConsulta === 'RELATORIO_SINTETICO_PLUS_SCORE_PJ'),
      consultas.find(c => c.tipoConsulta === 'RELATORIO_SINTETICO_PLUS_SCORE_SERASA_PJ'),
      consultas.find(c => c.tipoConsulta === 'RELATORIO_SINTETICO_PLUS_SCORE_SERASA_PF'),
      consultas.find(c => c.tipoConsulta === 'RELATORIO_UNIFICADO_PJ'),
      consultas.find(c => c.tipoConsulta === 'RELATORIO_UNIFICADO_PF'),
    ].filter(c => c);
    return consultasOrdenadas;
  }


  getTipoPessoa(key) {
    switch (key) {
      case 'RELATORIO_SINTETICO_PLUS_SCORE_PF':
      case 'RELATORIO_UNIFICADO_PF':
      case 'RELATORIO_SINTETICO_PLUS_SCORE_SERASA_PF':
        return 'PF';

      case 'RELATORIO_SINTETICO_PLUS_SCORE_PJ':
      case 'RELATORIO_SINTETICO_PLUS_SCORE_SERASA_PJ':
      case 'RELATORIO_UNIFICADO_PJ':
        return 'PJ';

      default:
        return 'PF';
    }
  }


  keyOrder(consultas:string[]) {
    let order = {
      score: 1,
      identificacao:2,
      localizacao: 3,
      consultas_anteriores_sintetico: 10,
      protesto: 20,
      pendencias_financeiras: 30,
      divida_vencida_serasa: 40,
      registro_scpc_bvs: 50,
      consultas_anteriores_scpc: 60,
      cheque_contra_ordem_outras_ocorrencias: 70,
      cheques_sem_fundo: 1010
    }

    return consultas.sort((a,b) => {
      const a_index = order[a] || 999;
      const b_index = order[b] || 999;
      if(a_index < b_index) return  -1;
      if(a_index > b_index) return 1;
      return 0;
    })

  }

  formatarConsultasFilhas() {
    this.consultasFilhas = [];
    this.dadosConsulta.consultas.forEach(c => {
      if (!c.consulta) return;

      let keys = this.keyOrder(Object.keys(c.consulta));

      for (const key of keys) {
        let consulta = c.consulta[key];
        
        if(!consulta ||  typeof consulta !== 'object') continue;

        if (key == 'insumos') {
          this.consultasFilhas = this.consultasFilhas.concat(this.formatarConsultasInsumos(consulta, c));
        }

        let r: any = { tipoPessoa: this.getTipoPessoa(c.tipoConsulta), tipoConsulta: key, registros: consulta.registros || null, codigoControle: consulta.codigoControle || 'SEMREGISTRO_OK' };


        //no futuro devera ter outras consultas aqui :D
        switch (key) {
          case 'consultas_anteriores_sintetico':
            r.registros = {
              sintetico: this.formatar_consultas_anteriores_sintetico(r.registros),
              analitico: (c.consulta.consultas_anteriores_analitico || c.consulta.insumos.consultas_anteriores_analitico).registros || []
            };
            if(r.registros.sintetico.length == 0 && r.registros.analitico.length == 0) {
              r.codigoControle = 'SEMREGISTRO_OK';
            }
            break;

          case 'renda_presumida':
          case 'localizacao':
          case 'identificacao':
          case 'score':
            r = { ...r, ...consulta };

          case 'pendencias_financeiras':
            r.informacoes = consulta.informacoes;

          default:
            break;
        }

        this.consultasFilhas.push(r);
        
      }
    });
  }

  formatarConsultasInsumos(insumos, consultaPrincipal) {
    let consultasFilhas = [];

    for (const key in insumos) {
      const consulta = insumos[key];

      if(consulta &&  typeof consulta == 'object') {
        let r: any = { tipoPessoa: this.getTipoPessoa(consultaPrincipal.tipoConsulta), tipoConsulta: key, registros: consulta.registros || null, codigoControle: consulta.codigoControle || 'SEMREGISTRO_OK' };
  
        switch (key) {
          default:
            break;
        }
        consultasFilhas.push(r);
      }
    }
    return consultasFilhas;
  }

  atualizarConsulta(index, novaConsulta) {
    this.consultas[index] = novaConsulta;
  }

  formatar_consultas_anteriores_sintetico(sintetico: { quantidade: number, referencia: string }[]) {
    if (!sintetico || sintetico.length==0) return [];
    let response = {};
    sintetico.forEach(r => {
      let [mes, ano] = r.referencia.split('/');
      response[ano] = response[ano] || new Array(12).fill(0);
      response[ano][Number.parseInt(mes) - 1] = r.quantidade;
    });
    return response;
  }

}
